import React from "react";

function RerenderSellerButton({ item, handleActionClick }) {
  const isPending =
    item?.status === "pending" ||
    item?.status === "cancelled" ||
    item?.status === "reject";
  const isDisabled =
    item?.status === "completed" ||
    item?.status === "cancelled" ||
    (isPending ? false : item?.status !== "accepted") ||
    item?.status === "reject";

  return (
    <button
      href="#actionModal"
      className={`button-style white-text ${
        isDisabled
          ? "grey lighten-2"
          : isPending
          ? "red lighten-1"
          : "green lighten-1"
      } pointer modal-trigger`}
      style={{
        padding: "5px 10px",
        width: "90px",
      }}
      onClick={() =>
        handleActionClick(item?._id, isPending ? "cancel" : "complete")
      }
      disabled={isDisabled}
    >
      {isPending ? "Cancel" : "Complete"}
    </button>
  );
}

export default RerenderSellerButton;
